import React from "react";
import FolderTreeNode from "./FolderTreeNode";
import { FolderTreeProps } from "./bookmark.types";

type NewType = React.FC<FolderTreeProps>;

const FolderTree: NewType = ({
    data,
    onSelect,
    onDrop,
    expandedKeys,
    setExpandedKeys,
    selectedFolder,
    level = 0,
}) => {
    if (!Array.isArray(data)) return null;
    return (
        <div>
            {data.map((item, index) => {
                if (item.type !== "folder") return null;
                return (
                    <React.Fragment key={`${item.id}-${index}`}>
                        <FolderTreeNode
                            item={item}
                            onSelect={onSelect}
                            onDrop={onDrop}
                            expandedKeys={expandedKeys}
                            setExpandedKeys={setExpandedKeys}
                            level={level}
                            isSelected={selectedFolder === item.id}
                        />
                        {Array.isArray(item.children) &&
                            item.children.length > 0 &&
                            expandedKeys.includes(item.id) && (
                                <FolderTree
                                    data={item.children}
                                    onSelect={onSelect}
                                    onDrop={onDrop}
                                    expandedKeys={expandedKeys}
                                    setExpandedKeys={setExpandedKeys}
                                    selectedFolder={selectedFolder}
                                    level={level + 1}
                                />
                            )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default FolderTree;